export default {
    '404':'Die gesuchte Seite konnte nicht gefunden werden.',
    get default(){
        return 'Es ist ein Fehler aufgetreten, bitte versuchen Sie es erneut oder kehren Sie zur Startseite zurück.';
    }
}